import { Alert, Button, Code, Group, Modal, Stack, Text } from '@mantine/core'
import { IconAlertTriangle, IconCopy } from '@tabler/icons-react'

import type { CredencialEmitida } from '@/api/robo'

/**
 * A credencial em claro aparece UMA vez.
 *
 * O backend guarda so' o hash — `registry.CAMPOS` nao expoe `token_sha256` e
 * nao existe rota que devolva o valor de novo. Por isso o aviso vem ANTES do
 * valor, e nao depois: quem le de baixo para cima ja copiou e fechou.
 */
export function CredencialModal(
  { credencial, onClose }: { credencial: CredencialEmitida | null; onClose: () => void },
) {
  return (
    <Modal opened={!!credencial} onClose={onClose} title="Credencial do robô" size="lg">
      <Stack gap="sm">
        <Alert color="yellow" icon={<IconAlertTriangle size={18} />}>
          Esta credencial é mostrada uma única vez. O Console guarda apenas o
          hash dela — quem fechar sem copiar precisa rotacionar de novo.
        </Alert>
        <Text size="sm">
          Grave-a no robô <strong>{credencial?.name}</strong>. Ela vale por 365 dias.
        </Text>
        <Code block>{credencial?.credential}</Code>
        <Group justify="flex-end">
          <Button
            variant="default"
            leftSection={<IconCopy size={16} />}
            onClick={() => navigator.clipboard?.writeText(credencial?.credential ?? '')}
          >
            Copiar
          </Button>
          <Button onClick={onClose}>Já copiei</Button>
        </Group>
      </Stack>
    </Modal>
  )
}
